import { Button, Form, Input, Modal } from 'antd';
import './style.less';
const { TextArea } = Input;

const ContactModel = (props: any) => {

    const {

        handleOk,
        handleCancel,
        isModalVisible,
        onFinish,
        form,
        btnLoading
    } = props;

    return (
        <>

            <Modal
                forceRender
                visible={isModalVisible}
                onCancel={handleCancel}
                centered={true}
                onOk={handleOk}
                width={602}
                footer={null}
                className="connect_modal"
                closeIcon={<div className="connect_icon"></div>}
            >
                {/* 联系我们 */}
                <Form
                    name="basic"
                    labelCol={{ span: 4 }}
                    wrapperCol={{span:18}}
                    form={form ? form : undefined}
                    // wrapperCol={{ span: 16 }}
                    className="modal_form"
                    labelAlign={"left"}
                    onFinish={onFinish}

                >
                    <div className="form_title">模型+硬件支持反馈</div>
                    <div className="form_desc">请在下方填入您所需要支持部署的模型/芯片型号等信息，我们会了解您的需求后尽快联系您，谢谢支持</div>
                    <Form.Item
                        label="模型类型"
                        name="model_type"
                        rules={[{ required: true, message: '内容不能为空' }]}
                    >
                        <Input
                            allowClear
                            placeholder="例如：“PP-LCNetv1”"
                        />
                    </Form.Item>

                    <Form.Item
                        label="模型名称"
                        name="model_name"
                        rules={[{ required: true, message: '内容不能为空' }]}
                    >
                        <Input
                            allowClear
                            placeholder="例如：“ResNet”"
                        />
                    </Form.Item>


                    <Form.Item
                        label="部署芯片"
                        name="deployment_of_chip"
                        rules={[{ required: true, message: '内容不能为空' }]}
                    >
                        <Input
                            allowClear
                            placeholder="例如：“百度昆仑XPU-K100”"
                        />
                    </Form.Item>

                    <Form.Item
                        label="联系方式"
                        name="phone"
                        rules={[
                            { required: true, message: '内容不能为空' },
                            {
                                pattern: /^1[3|4|5|7|8][0-9]\d{4,8}$/,
                                message: '您填写的手机号格式错误'
                            }
                        ]}
                    >
                        <Input
                            allowClear
                            placeholder="请输入您的电话号码，便于我们联系您"
                        />
                    </Form.Item>
                    <Form.Item
                        label="需求描述"
                        name="demand_desc"
                        rules={[
                            { required: true, message: '内容不能为空' },
                            {
                                min: 20,
                                message: "需求描述文字少于20字"
                            },
                            {
                                max: 500,
                                message: "需求描述文字多于500字"
                            }
                        ]}
                    >
                        <TextArea
                          
                            showCount
                            placeholder="请简要描述模型部署应用的场景，最少20字"
                            maxLength={500}
                            className="text"
                            bordered={false}
                            autoSize={false}
                        ></TextArea>
                    </Form.Item>
                    <div
                        className="btn"
                      
                    >
                        <Button type="primary" htmlType="submit" loading={btnLoading}>
                            提交
                        </Button>
                        <Button htmlType="button" type="default" onClick={() => handleCancel()}>
                            取消
                        </Button>

                    </div>
                </Form>
            </Modal>

        </>
    )
}

export default ContactModel;